import reducer from './feedbackReducer';
import actions from './feedbackActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
